module.exports = __webpack_public_path__ + "img/manualTask.d80701de.svg";